<template>
  <v-container class="pt-0">
    <v-row>
      <v-col class="mx-0 px-0 pt-0">
        <header-text-bg :site="site" :text="title" />
      </v-col>
    </v-row>

    <v-container fluid class="pa-0">
      <v-row>
        <v-card
          v-if="profileData"
          class="level-card relative mx-4 mt-4"
          elevation="3"
          style="width: 100%"
        >
          <v-container class="pa-4">
            <v-row align="center">
              <v-col cols="12" class="d-flex">
                <div class="level-image-container">
                  <img
                    style="
                      width: auto !important;
                      height: 100%;
                      aspect-ratio: 1;
                      border-radius: 8px;
                      object-fit: cover;
                    "
                    :style="{
                      'background-color': site.color || '#eeeeee',
                    }"
                    class="level-image"
                    :src="profileData.image"
                  />
                </div>
                <div class="pl-4" style="width: 100%">
                  <div class="member-name">
                    {{ profileData.name }} {{ profileData.surname }}
                  </div>
                  <div class="member-name">
                    {{ $t("code") }} : {{ profileData.code }}
                  </div>
                  <!-- <v-divider class="my-2"></v-divider> -->
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-row>

      <!-- ========== ========== Tag ========== ========== -->
      <v-row>
        <v-col
          v-for="(item, index) in listTag"
          :key="index"
          cols="12"
          class="pb-0"
        >
          <div
            class="d-flex align-center pa-4 justify-space-between"
            :style="{
              background: setBackgoundBox(item.color || '#000000'),
              color: `${getFontColorBasedOnBg(
                item.color || '#FFFFFF',
                'bw'
              )} !important`,
              'box-shadow': '0 2px 6px rgba(0, 0, 0, 0.2)',
            }"
            style="border-radius: 8px; font-weight: bold"
            @click="handleClickTag(item)"
          >
            <div>{{ item.name }}</div>
            <v-icon color="#ffffff">mdi-chevron-right</v-icon>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import Axios from "@/config/customer-service";
import HeaderTextBg from "../../../components/headerTextBg.vue";
import { mapState } from "vuex";
import {
  adjustHslBrightness,
  getFontColorBasedOnBg,
} from "@/config/general-function";

export default {
  inject: ["isAppLoading"],
  components: {
    HeaderTextBg,
  },
  data: () => ({
    title: "",
    profileData: null,
    listTag: [],
  }),
  async created() {
    const menu = JSON.parse(this.site.menu_account);
    const model = menu?.find((x) => x.to == "my-tag");
    this.title = model?.name;
    this.isAppLoading(true);
    // ========== ========== Profile ========== ==========
    let _profileData = this.getCustomer || {};
    _profileData.image =
      _profileData.image || require("@/assets/images/user-only.svg");
    this.profileData = _profileData;
    // ========== ========== ========== ==========
    this.getListTagEntity();
    this.isAppLoading(false);
  },
  methods: {
    async getListTagEntity() {
      try {
        let response = await Axios.get(`/getListTagEntity`, {
          params: {
            entity_id: this.customer.id,
            entity_type: "employee",
          },
        });
        const dataResponse = response?.data;
        if (dataResponse.status == "success") {
          const data = dataResponse.data || [];
          this.listTag = [...data];
        }
      } catch (err) {
        console.log("getListTagEntity", err);
      }
    },

    getFontColorBasedOnBg(param, param2) {
      const res = getFontColorBasedOnBg(param, param2);
      return res;
    },
    setBackgoundBox(param) {
      const _color = param;
      const darken = adjustHslBrightness(_color, -20);
      const lighten = adjustHslBrightness(_color, 20);
      let _style = `linear-gradient(120deg, ${darken}, ${_color}, ${lighten}, ${_color}, ${darken})`;
      return _style;
    },

    handleClickTag(param) {
      this.$router.push({
        name: "my-tag-detail",
        params: { id: param.id },
      });
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
    getCustomer() {
      return { ...this.$store.getters["defaultSystem/getCustomer"] };
    },
  },
  filters: {},
};
</script>

<style scoped>
.level-card {
  border-radius: 12px !important;
  color: #333;
  overflow: hidden;
}

.member-name {
  font-size: 16px;
  font-weight: 500;
}

.member-code {
  font-size: 14px;
  font-weight: 500;
}

.level-image {
  border-radius: 12px;
  object-fit: cover;
  height: 100%;
  width: 100%;
}

.level-image-container {
  width: 100%;
  max-width: 120px;
  aspect-ratio: 1;
  overflow: hidden;
  border-radius: 12px;
}
</style>

